import React from 'react';
import '../giveaway.css';

export const GiveawayBrandFrame = ({ brand, children }) => (
  <div className="giveaway-page ph-no-capture ph-mask" style={{ '--giveaway-accent': brand?.accent || '#F59E0B', '--giveaway-background': brand?.background || '#131315' }} data-testid="giveaway-page">
    <div className="giveaway-shell">
      <header className="giveaway-brand-header">
        {brand?.logo_url
          ? <img src={brand.logo_url} alt={brand.name} className="giveaway-logo" data-testid="giveaway-brand-logo" />
          : <strong className="giveaway-wordmark" data-testid="giveaway-brand-name">{brand?.name || 'Monthly giveaway'}</strong>}
        <span className="giveaway-eyebrow" data-testid="giveaway-month-label">Monthly giveaway</span>
      </header>
      {children}
      <footer className="giveaway-footer" data-testid="giveaway-disclaimer">
        No purchase necessary. Following on Instagram is not required to enter or win.
        <span>Powered by Advecti</span>
      </footer>
    </div>
  </div>
);